/* assets/recipe-live-search.js */
document.addEventListener('DOMContentLoaded', () => {
  const search = document.getElementById('recipe-live-search');
  if (!search) return;

  /* Adjust this selector to match your card’s outer element */
  const cards = Array.from(document.querySelectorAll('.article, .recipe-card, .rk-recipe, .grid__item'));

  const normalise = str => str.toLowerCase().trim();

  search.addEventListener('input', e => {
    const q = normalise(e.target.value);
    cards.forEach(card => {
      const haystack = normalise(card.textContent);
      card.style.display = haystack.includes(q) ? '' : 'none';
    });
  });
});
